export const theme = {
    colors: {
        gradientPurple:'transparent linear-gradient(122deg, #E53E57 0%, #592C82 100%) 0% 0% no-repeat padding-box;',
        gradientPurpleButton:'transparent linear-gradient(180deg, #7C2280 0%, #2D1641 100%) 0% 0% no-repeat padding-box;',
        letterColor: '#592C82',
        borderMenu: '#00ACA6',
    },

    fonts: {
        calibri:'normal normal bold 22px/46px Calibri',
        CreateAccount:'normal normal 300 16px/46px Calibri,'
    }
    
}

